import { createSelector } from 'reselect';
const getNavConfig = state => state.navConfig;
export const getHomePageOptions = createSelector([getNavConfig], navConfig => navConfig);